// Theme: cosmic-void
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'cosmic-void',
  name: 'COSMIC VOID',
  tagline: 'COSMIC VOID',
  description: 'Recolor void indigo do cosmic com a mesma estrutura epica.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#080A12', '#312E81', '#10152A', '#C9D4FF'],
  familyId: 'cosmic',
  variantName: 'VOID',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-sans theme-cosmic-void'
  },
  colorVars: {
    '--accent': '#312E81',
    '--accent-foreground': '#080A12',
    '--background': '#080A12',
    '--border': '#2A3060',
    '--card': '#10152A',
    '--card-border-active': 'rgba(49, 46, 129, 0.48)',
    '--card-completed': '#10152A',
    '--card-foreground': '#C9D4FF',
    '--card-glow': 'rgba(49, 46, 129, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#080A12',
    '--foreground': '#C9D4FF',
    '--hold-fill': '#312E81',
    '--input': '#10152A',
    '--modal-bg': '#080A12',
    '--modal-border': '#2A3060',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A3060',
    '--muted-foreground': '#C9D4FF',
    '--nav-active': '#312E81',
    '--nav-bg': '#080A12',
    '--popover': '#10152A',
    '--popover-foreground': '#C9D4FF',
    '--primary': '#312E81',
    '--primary-foreground': '#080A12',
    '--ring': '#312E81',
    '--secondary': '#2A3060',
    '--secondary-foreground': '#C9D4FF',
    '--streak': '#312E81',
    '--success': '#22C55E',
    '--success-foreground': '#080A12',
    '--xp': '#312E81',
    '--xp-bg': '#10152A'
  },
  resolvedVars: {
    '--accent': '#312E81',
    '--accent-foreground': '#080A12',
    '--accent-foreground-hsl': '228 38% 5%',
    '--accent-foreground-oklch': 'from #080A12 l c h',
    '--accent-hsl': '242 47% 34%',
    '--accent-oklch': 'from #312E81 l c h',
    '--background': '#080A12',
    '--background-hsl': '228 38% 5%',
    '--background-oklch': 'from #080A12 l c h',
    '--border': '#2A3060',
    '--border-hsl': '233 39% 27%',
    '--border-oklch': 'from #2A3060 l c h',
    '--border-w': '1px',
    '--card': '#10152A',
    '--card-border-active': 'rgba(49, 46, 129, 0.48)',
    '--card-completed': '#10152A',
    '--card-completed-hsl': '228 45% 11%',
    '--card-completed-oklch': 'from #10152A l c h',
    '--card-foreground': '#C9D4FF',
    '--card-foreground-hsl': '228 100% 89%',
    '--card-foreground-oklch': 'from #C9D4FF l c h',
    '--card-glow': 'rgba(49, 46, 129, 0.1)',
    '--card-hsl': '228 45% 11%',
    '--card-oklch': 'from #10152A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#080A12',
    '--destructive-foreground-hsl': '228 38% 5%',
    '--destructive-foreground-oklch': 'from #080A12 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#C9D4FF',
    '--foreground-hsl': '228 100% 89%',
    '--foreground-oklch': 'from #C9D4FF l c h',
    '--hold-fill': '#312E81',
    '--hold-fill-hsl': '242 47% 34%',
    '--hold-fill-oklch': 'from #312E81 l c h',
    '--input': '#10152A',
    '--input-hsl': '228 45% 11%',
    '--input-oklch': 'from #10152A l c h',
    '--modal-bg': '#080A12',
    '--modal-bg-hsl': '228 38% 5%',
    '--modal-bg-oklch': 'from #080A12 l c h',
    '--modal-border': '#2A3060',
    '--modal-border-hsl': '233 39% 27%',
    '--modal-border-oklch': 'from #2A3060 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A3060',
    '--muted-foreground': '#C9D4FF',
    '--muted-foreground-hsl': '228 100% 89%',
    '--muted-foreground-oklch': 'from #C9D4FF l c h',
    '--muted-hsl': '233 39% 27%',
    '--muted-oklch': 'from #2A3060 l c h',
    '--nav-active': '#312E81',
    '--nav-active-hsl': '242 47% 34%',
    '--nav-active-oklch': 'from #312E81 l c h',
    '--nav-bg': '#080A12',
    '--nav-bg-hsl': '228 38% 5%',
    '--nav-bg-oklch': 'from #080A12 l c h',
    '--popover': '#10152A',
    '--popover-foreground': '#C9D4FF',
    '--popover-foreground-hsl': '228 100% 89%',
    '--popover-foreground-oklch': 'from #C9D4FF l c h',
    '--popover-hsl': '228 45% 11%',
    '--popover-oklch': 'from #10152A l c h',
    '--primary': '#312E81',
    '--primary-foreground': '#080A12',
    '--primary-foreground-hsl': '228 38% 5%',
    '--primary-foreground-oklch': 'from #080A12 l c h',
    '--primary-hsl': '242 47% 34%',
    '--primary-oklch': 'from #312E81 l c h',
    '--radius': '12px',
    '--ring': '#312E81',
    '--ring-hsl': '242 47% 34%',
    '--ring-oklch': 'from #312E81 l c h',
    '--secondary': '#2A3060',
    '--secondary-foreground': '#C9D4FF',
    '--secondary-foreground-hsl': '228 100% 89%',
    '--secondary-foreground-oklch': 'from #C9D4FF l c h',
    '--secondary-hsl': '233 39% 27%',
    '--secondary-oklch': 'from #2A3060 l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#312E81',
    '--streak-hsl': '242 47% 34%',
    '--streak-oklch': 'from #312E81 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#080A12',
    '--success-foreground-hsl': '228 38% 5%',
    '--success-foreground-oklch': 'from #080A12 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(242 47% 34% / 0.15)',
    '--xp': '#312E81',
    '--xp-bg': '#10152A',
    '--xp-bg-hsl': '228 45% 11%',
    '--xp-bg-oklch': 'from #10152A l c h',
    '--xp-hsl': '242 47% 34%',
    '--xp-oklch': 'from #312E81 l c h'
  }
}
